<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IItem } from '@posx/core'

const { t, locale } = useI18n()

const $props = defineProps<{
  modelValue?: string[]; // 选中的产品 UIDs
  availableProducts?: IItem[]; // 可选的产品列表
  rootFormData?: any; // 根表单数据，包含 selectedItems
}>();

const $emit = defineEmits<{
  (event: 'update:modelValue', value: string[]): void;
  (event: 'change', value: string[]): void;
}>();

const selectedProductUids = ref<string[]>($props.modelValue || []);

// 监听外部值变化
watch(
  () => $props.modelValue,
  (newValue) => {
    selectedProductUids.value = newValue || [];
  }
);

// 计算可用的产品列表
const availableProducts = computed(() => {
  // 优先使用直接传入的产品列表
  if ($props.availableProducts) {
    return $props.availableProducts;
  }
  // 否则从 rootFormData 中获取 selectedItems
  if ($props.rootFormData && $props.rootFormData.selectedItems) {
    return $props.rootFormData.selectedItems;
  }
  return [];
});

// 监听可用产品变化，确保选中的产品仍然有效
watch(
  availableProducts,
  (newProducts) => {
    if (newProducts) {
      const validUids = newProducts.map((p: IItem) => p.uid);
      selectedProductUids.value = selectedProductUids.value.filter(uid => validUids.includes(uid));
    }
  },
  { deep: true }
);

const handleSelectionChange = (selectedUids: string[]) => {
  selectedProductUids.value = selectedUids;
  $emit('update:modelValue', selectedUids);
  $emit('change', selectedUids);
};
</script>

<template>
  <el-select
    v-model="selectedProductUids"
    multiple
    :placeholder="t('common.select_product')"
    @change="handleSelectionChange"
    class="w-full"
    collapse-tags
    :max-collapse-tags="3"
  >
    <el-option
      v-for="item in availableProducts"
      :key="item.uid"
      :label="item.name_translations?.[locale] || item.name"
      :value="item.uid"
    />
  </el-select>
</template>

<style scoped>
/* 样式保持与现有组件一致 */
</style>
